import * as React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => (
  <div className="d-flex align-items-center justify-content-center my-5">
    <div className="text-center my-5  py-5">
      <div className="d-flex justify-content-center my-4">
        <h1 className="display-1 fw-bold text-danger me-3">4</h1>
        <img src="/img/robot.gif" width="100px" height="100px" alt="Page not found" style={{ maxWidth: '100%' }} />
        <h1 className="display-1 fw-bold text-danger ms-3">4</h1>
      </div>
      <p className="fs-3">Az oldal nem található.</p>
      <p className="lead">A keresett oldal nem létezik, vagy bejelentkezés nélkül nem megtekinthető. </p>
      <Link to={'/'} className="btn btn-primary">
        Vissza a főoldalra
      </Link>
    </div>
  </div>
);
